import instance from 'utils/axios/instance.axios';
import { EMPLOYEES } from './_constant';

export const getAllEmployees = (pagination, search) =>
  instance.get(EMPLOYEES.GET_ALL, { params: { ...pagination, search } });

export const downloadScientificProfileFile = ({ userId }) =>
  instance.post(EMPLOYEES.DOWNLOAD_SCIENTIFIC_PROFILE_FILE, { userId }, { responseType: 'blob' });
